import {
  Base64UrlDecoder as Decoder,
  Base64UrlEncoder as Encoder,
} from "next-base64-encoder"
import { make_encoder } from "workflow/utils/base64"

export default make_encoder(Encoder, Decoder)
